import { SxStyleProp } from 'theme-ui';

export const baseStyle: { [k: string]: SxStyleProp } = {
  mainContainer: {
    color: 'white',
    textAlign: ['center', 'left'],
    padding: ['40px 34px 50px', '65px 0px'],
  },
  title: {
    marginBottom: ['20px', '25px'],
  },
  subtitle: {
    marginBottom: ['40px', '60px'],
  },
  cardContainer: {
    flexDirection: ['column', 'row'],
    background: 'white',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: ['12px'],
    color: 'black.100',
    textAlign: ['center', 'left'],
    padding: ['20px 14px', '30px 45px'],
  },
  cardContainerLeft: {
    paddingTop: [null, '50px'],
  },
  cardContainerRight: {
    display: ['none', 'flex'],
    alignItems: 'center',
    width: '100%',
    minWidth: '54%',
    marginLeft: '40px',
  },
  cardTitle: {
    marginBottom: ['18px'],
    padding: ['0px'],
  },
  cardSubtitle: {
    marginBottom: ['20px', '38px'],
  },
  cardCta: {
    margin: ['0 auto', '0'],
  },
  cardResponsiveImageContainer: {
    display: ['block', 'none'],
    width: '100%',
    marginBottom: '18px',
  },
  cardResponsiveImage: {
    objectFit: 'contain',
    width: '100%',
    height: '100%',
  },
  cardImageContainer: {
    flex: 1,
  },
  cardImage: {
    objectFit: 'contain',
    width: '100%',
    height: '100%',
  },
  signUpContainer: {
    marginTop: ['40px'],
  },
};
